import { createSelector } from 'reselect';
import { cultureVisitingsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const cultureVisitingsYearsSelector = createSelector([cultureVisitingsSelector], (cultureVisitings) =>
  extractDatesFromNestedItems(
    [cultureVisitings.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
